// extracted by mini-css-extract-plugin
export default {"Title":"Posts_Title__AvN34","Posts":"Posts_Posts__GYTXn","createPost":"Posts_createPost__Bm826","Form":"Posts_Form__YwVw2"};